export const columnData = [
  { name: 'Código', widthCol: '10%' },
  { name: 'Nombre', widthCol: '30%' },
  { name: 'Símbolo', widthCol: '30%' },
  { name: 'Ver datos', widthCol: '30%' }
]
